import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";


export class GetDistinctSensorsDataResData extends ServiceResponseData {
    public sensorModels: string[];
    public sensorFirmwares: string[];

    constructor(response: AxiosResponse) {
        super(response);
        this.sensorModels = [];
        this.sensorFirmwares = [];
        if (response.data && response.data.Payload) {
            this.sensorModels = response.data.Payload.SensorModels;
            this.sensorFirmwares = response.data.Payload.SensorFirmwares;
        }
    }

}